<template>
  <div class="ma-1">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Reporting'
}
</script>

<style scoped>

</style>
